'use strict';
Groupon.loadSiteBlindado = function() {
  var script;
  script = document.createElement('script');
  script.setAttribute('async', '');
  return document.body.appendChild(script).src = "//cdn.siteblindado.com/aw.js";
};

